import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  challenges: [],
  challengesLoaded: false,
  archivedChallenges: {},
  archivedChallengesLoaded: false,
  getChallengesByMemberId: [],
  member: {},
  memberCopy: {},
  getMemberByName: {},
  memberLoaded: false,
  deleteInProgress: false,
  memberTeams: [],
  memberTeamsLoaded: false,
  memberTeamInvites: [],
  memberTeamInvitesLoaded: false,
  getTeamsByMemberId: [],
  getFriendsByMemberId: [],
  teamsMemberIsAdmin: [],
  teamsMemberIsAdminLoaded: false,
  challengeInvites: [],
  joinRequestMessages: [],
  memberFriends: [],
  friendsLoaded: false,
  friendsLoadedByMemberId: false,
  friendsRequesting: [],
  friendsRequestingLoaded: false,
  friendsInvited: [],
  friendsInvitedLoaded: false,
  acceptFriendInviteProcessing: false,
  sendFriendInviteProcessing: false,
  removeFriendProcessing: false,
  stepData: [],
  wellnessChartData: [],
  getStepDataByMemberId: [],
  stepDataLoaded: false,
  metricDataLoaded: false,
  isJournalLastPage: false,
  journals: [],
  journalEntryStats: {},
  makeAnEntryJournal: {},
  makeAnEntryJournalLoading: false,
  journalPageJournal: {},
  journalPageJournalLoading: false,
  getJournalsByMemberId: [],
  journalsLoaded: false,
  activities: [],
  activitiesLoaded: false,
  activitiesLoading: false,
  milestonesLoaded: false,
  messages: {},
  messageCount: 0,
  getLeaderboardByMemberId: {},
  leaderboardLoaded: false,
  getMilestonesById: [],
  memberNotice: [],
  memberNoticeLoaded: false,
  deviceApi: {},
  points: {},
  pointsLoaded: false,
  memberOrganizationNotice: {},
  memberOrganizationNoticeLoaded: false,
  mobileChallenges: [],
  mobileChallengeLoaded: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
